import React from 'react';
import Logo from './Logo';

const LoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      <Logo className="w-16 h-16 animate-pulse" />
    </div>
  );
};

export default LoadingState; 